<template>
  <div class="upload-component">
    <v-file-input v-model="files" v-show="!onlyDisplay" :accept="accept"
      :label="label != null ? label : internalFiles ? multiple ? $t('upload_internal_' + suffix_plural) : $t('upload_internal_' + suffix) : multiple ? $t('upload_' + suffix_plural) : $t('upload_' + suffix)"
      class="datainput justify-content-end align-self-center pb-1 file-input" dense outlined :multiple="multiple"
      :placeholder="multiple ? $t('select_multiple_' + suffix_plural) : $t('select_one_' + suffix)" prepend-icon=""
      clearable="false" @change="selectedFile">
      <template v-slot:selection="{ index, file }">
        <div class="file-selection" v-if="index && file">
        </div>
        Select File...
      </template>
    </v-file-input>
    <div class="already-uploaded">
      <div class="file-selection" v-for="filename in fileNames" :key="filename">
        <span class="file-name" @click="showFile(filename)">{{ getUploadedFileDisplayName(filename) }}</span>
        <span class="file-delete" v-show="!onlyDisplay">
          <v-icon @click.stop="removeFile(filename)" color="#24695C">fas fa-trash</v-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AWS from 'aws-sdk'
// import { singleUpload, deleteObjectByKey } from '@/aws.js'
// const aws = require('aws-sdk');
export default {

  props: {
    label: {
      type: String,
      default: function () {
        return null;
      }
    },
    vModelPrefix: {
      type: String,
      default: function () {
        return null;
      }
    },
    maxSize: {
      type: Number,
      default: function () {
        return 1000;
      }
    },
    multiple: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    allowOtherFileTypes: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    internalFiles: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    onlyDisplay: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    value: Array // for v-model Binding
  },

  data() {
    return {
      newFilesSelected: false,
      accept: "image/png, image/gif, image/jpeg, image/jpg, video/mp4, video/mov, video/avi, video/webm",
      suffix: "image",
      suffix_plural: "images",

      size: {
        height:'',
        width:''
      },
      imageLoaded: false,

      s3Bucket: new AWS.S3({
        signatureVersion: 'v4',
        region: 'eu-central-1',
        accessKeyId: this.$accessKeyId, // env variable
        secretAccessKey: this.$secretAccessKey // env variable
      }),
    }
  },

  computed: {
    fileNames: {
      get() {
        if (typeof this.value == "string") {
          return [this.value];
        }
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  watch:{
    value: {
      handler(val){
        console.log(val);
      },
      deep:true,
    }
  },

  mounted() {
    console.log(this.value);
    if (this.allowOtherFileTypes) {
      this.accept = "/*";
      this.suffix = "file";
      this.suffix_plural = "files";
    }
    // this.fileNames = [];
  },

  methods: {
    selectedFile(files){
      this.imageLoaded = false;


      let file = files;
      if(!file || file.type.indexOf('image/') !== 0) return;

      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          this.size.width = img.width;
          this.size.height = img.height;
          this.imageLoaded = true;
          if(this.size.width < 100){
            this.$noty.error(this.$t('upload_square_image') + this.size.width + 'x' + this.size.height);
            return;
          }
          if(this.size.width != this.size.height){
            this.$noty.warning(this.$t('upload_square_image_warning') + this.size.width + 'x' + this.size.height);
          }
          this.handleUpload(files);
        }
        img.src = evt.target.result;
      }

      reader.onerror = evt => {
        console.error(evt)
      }
    },
    handleUpload(files) {
      var _this = this;
      if (this.multiple) {
        for (let i = 0; i < files.length; i++) {
          console.log(files[i].type); //image/jpeg
          const type = files[i].type.substring(files[i].type.lastIndexOf('/') + 1);
          this.s3Bucket.createBucket(function () {
            const params = {
              Bucket: _this.$bucket,
              Body: files[i],
              ContentType: files[i].type,
              Key: _this.$user.id + `/${Date.now()}.${type}`
            }
            _this.s3Bucket.upload(params, async function (err, data) {
              if (err) console.log(err)
              else {
                var arr = [];
                arr.push(data.Location);
                _this.fileNames = arr;
              }
            })
          })
        }

      } else {
        console.log("files", files);
        const type = files.type.substring(files.type.lastIndexOf('/') + 1);
        this.s3Bucket.createBucket(function () {
          const params = {
            Bucket: _this.$bucket,
            Body: files,
            ContentType: files.type,
            Key: _this.$user.id + `/${Date.now()}.${type}`
          }
          _this.s3Bucket.upload(params, async function (err, data) {
            if (err) console.log(err)
            else {
              _this.fileNames = data.Location;
            }
          })
        })
      }


    },

    showFile(fileName) {
      var win = window.open(fileName, "_blank");
      win.focus();
    },

    getFileSize(file) {
      return Math.floor(file.size / 10000) / 100;
    },

    getUploadedFileName(fileName) {
      if (fileName.includes("__")) {
        return fileName.substring(fileName.indexOf("__") + 2);
      }
      return fileName;
    },

    getUploadedFileDisplayName(fileName) {
      var fn = this.getUploadedFileName(fileName);
      if(fn.includes("/")) return fn.substring(fn.lastIndexOf("/") + 1);
      return fn;
    },

    removeFile(fileName) {
      for (let i = 0; i < this.fileNames.length; i++) {
        const file = this.fileNames[i];
        if (file == fileName) {
          this.fileNames.splice(i, 1);
          break;
        }
      }

      if (this.vModelPrefix != null) fileName = fileName.substring(this.vModelPrefix.length);

      var key = fileName.substring(10);
      key = key.substring(key.indexOf("/") + 1);
      this.s3Bucket.deleteObject({
          Bucket: this.$bucket,
          Key: key
        }, (s3Error, data) => {
        if (s3Error) {
          return new Error(s3Error);
        }
        return null;
      });
    },

    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
  }
}
</script>
